import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "advisor", phone: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created.");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--kk-bg)] p-6">
      <form className="w-full max-w-md" onSubmit={submit}>
        <div className="kk-overline mb-2">Enrollment</div>
        <h1 className="font-display text-4xl uppercase">Create Account</h1>
        <p className="text-[var(--kk-muted)] text-sm mt-2">Join the Karr Kraft team.</p>
        <div className="mt-8 space-y-5">
          <div>
            <span className="kk-label">Full name</span>
            <input className="kk-input" value={form.name} onChange={upd("name")} required data-testid="reg-name" />
          </div>
          <div>
            <span className="kk-label">Email</span>
            <input className="kk-input" type="email" value={form.email} onChange={upd("email")} required data-testid="reg-email" />
          </div>
          <div>
            <span className="kk-label">Password</span>
            <input className="kk-input" type="password" value={form.password} onChange={upd("password")} required minLength={6} data-testid="reg-password" />
          </div>
          <div>
            <span className="kk-label">Phone</span>
            <input className="kk-input" value={form.phone} onChange={upd("phone")} data-testid="reg-phone" />
          </div>
          <div>
            <span className="kk-label">Role</span>
            <select className="kk-input" value={form.role} onChange={upd("role")} data-testid="reg-role">
              <option value="admin">Admin</option>
              <option value="advisor">Service Advisor</option>
              <option value="mechanic">Mechanic</option>
              <option value="storekeeper">Store Keeper</option>
              <option value="accountant">Accountant</option>
            </select>
          </div>
        </div>
        <button disabled={loading} className="kk-btn-primary mt-8 w-full justify-center" data-testid="reg-submit">
          {loading ? "Creating…" : "Create Account →"}
        </button>
        <div className="mt-6 text-xs text-[var(--kk-muted)]">
          Already have one?{" "}
          <Link to="/login" className="text-[var(--kk-black)] font-semibold underline">
            Sign in
          </Link>
        </div>
      </form>
    </div>
  );
}
